var map = {
	"./jf01.webp": 4126,
	"./jf02.webp": 2767,
	"./jf03.webp": 2524,
	"./jf04.webp": 5101,
	"./jf05.webp": 9538,
	"./jf06.webp": 7187,
	"./jf07.webp": 432,
	"./jf8.webp": 8247
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9444;